import Rails from "@rails/ujs";
Rails.start();
import "../stylesheets/application.scss";
const images = require.context("images", true);
const imagePath = (name) => images(name, true);

document.addEventListener("DOMContentLoaded", () => {
  const body = document.querySelector("body");
  const globalNavi = document.getElementById("globalNavi");
  const menuBtn = document.getElementById("menu-btn");

  // グローバルナビはデフォルトがアクティブになっている
  // これをスマホ幅での閲覧時のみデフォルトを非アクティブにしたいので下記の処理を実行
  if (window.innerWidth < 1000) {
    body.classList.remove("menuActive");
  }

  // 上記処理が走る際、メニュー開閉時のぬるっとしたアニメーションのために必要なcssのtransitionが
  // 悪影響(ロード後にぬるっとナビが非表示になる)を及ぼすため下記でロード後に後付けしている
  setTimeout(function () {
    if (globalNavi) {
      globalNavi.style.transition = "0.3s";
      menuBtn.style.transition = "0.3s";
    }
    const mainContainer = document.getElementById("mainContainer");
    mainContainer.style.transition = "0.3s";
    const header = document.querySelector("header");
    header.style.transition = "0.3s";
  }, 600);

  if (menuBtn) {
    menuBtn.onclick = () => body.classList.toggle("menuActive");
  }

  document.getElementById("dimmer").onclick = () => body.classList.remove("menuActive");

  const toggleMenu = function () {
    const parent = this.parentNode;
    if (parent.classList.contains("active")) {
      parent.classList.remove("active");
    } else {
      parent.classList.add("active");
    }
  };

  document.querySelectorAll(".naviItemHeader").forEach(function (header) {
    header.addEventListener("click", toggleMenu);
  });

  const changeMenu = function (tabId) {
    const url = `${location.pathname}?tab=${tabId}`;
    history.pushState(null, null, url);
    const editCreatorMenus = document.querySelectorAll(".editCreatorMenu");
    if (editCreatorMenus) {
      editCreatorMenus.forEach(function (menu) {
        if (menu.dataset.id == tabId) {
          menu.classList.add("active");
        } else {
          menu.classList.remove("active");
        }
      });
    }
  };

  const changeTab = function () {
    const tabId = this.dataset.id;
    const tabType = this.dataset.type;
    if (tabType == "linkMenu") {
      changeMenu(tabId);
    }
    document.querySelectorAll(".tab-item").forEach(function (item) {
      if (item.dataset.id == tabId) {
        item.classList.add("active");
        item.querySelector("a").classList.add("active");
      } else {
        item.classList.remove("active");
        item.querySelector("a").classList.remove("active");
      }
    });
    const tab = document.getElementById(`tab${tabId}`);
    if (tab) {
      document.querySelectorAll(".tabBody").forEach(function (body) {
        if (body.id == `tab${tabId}`) {
          body.classList.add("active");
        } else {
          body.classList.remove("active");
        }
      });
    }
  };

  document.querySelectorAll(".tab-item").forEach(function (item) {
    item.addEventListener("click", changeTab);
  });

  const flashMessage = document.getElementById("flashMessage");
  if (flashMessage) {
    setTimeout(function () {
      flashMessage.classList.add("fadeout");
      setTimeout(function () {
        flashMessage.style.display = "none";
      }, 500);
    }, 5000);
  }

  const careerAddBtn = document.getElementById("careerAddBtn");
  if (careerAddBtn) {
    careerAddBtn.addEventListener("click", addCareerBox);
  }

  document.querySelectorAll(".closeBtn.deleteCareer").forEach(function (btn) {
    btn.addEventListener("click", function (event) {
      const checkbox = event.target.previousElementSibling;
      checkbox.checked = true;
      event.target.parentNode.querySelectorAll("input, textarea").forEach(function (elm) {
        elm.required = false;
      });
      event.target.parentNode.classList.add("hide");
      const addBtn = document.getElementById("careerAddBtn");
      if (!addBtn) {
        appendCareerAddBtn();
      }
      updateCareers();
    });
  });

  document.querySelectorAll(".kana_check").forEach(function (input) {
    input.addEventListener("change", function () {
      const str = this.value;
      if (!str.match(/^[ァ-ヶー　]+$/)) {
        this.value = "";
        alert("全角カタカナで入力してください");
      }
    });
  });

  document.querySelectorAll(".career_start").forEach(function (input) {
    input.addEventListener("change", checkCareerEnd);
  });

  document.querySelectorAll(".career_end").forEach(function (input) {
    input.addEventListener("change", checkCareerStart);
  });

  document.querySelectorAll(".validUrlMaxLength").forEach(function (input) {
    input.addEventListener("change", validUrlMaxLength);
  });

  const copyButton = document.getElementById("copyButton");
  const tagText = document.getElementById("copyText");
  const message = document.getElementById("copyMessage");

  // クリップボードへコピー（ボタンをクリックした時）
  if (copyButton) {
    copyButton.addEventListener("click", () => {
      const tagValue = tagText.value;
      copyToClipboard(tagValue);
    });
  }

  // クリップボードへコピー（コピーの処理）
  function copyToClipboard(tagValue) {
    if (navigator.clipboard) {
      return navigator.clipboard.writeText(tagValue).then(function () {
        messageActive();
      });
    } else {
      tagText.select();
      document.execCommand("copy");
      messageActive();
    }
  }

  // メッセージを表示
  function messageActive() {
    message.classList.add("is-active");
    setTimeout(() => {
      message.classList.remove("is-active");
    }, 1600);
  }
});

window.showErrorDialog = function (msg) {
  alert(`エラーが発生しました\n${msg}`);
};

window.showDialog = function (msg) {
  alert(msg);
};

document.querySelectorAll(".duplicateCheckInput").forEach(function (input) {
  input.addEventListener("change", checkDuplicate);
});
let careerFormBoxCount = 0;
window.addCareerBox = function () {
  const i = document.querySelectorAll(".careerFormBox").length;
  const j = document.querySelectorAll(".careerFormBox.hide").length;
  const k = i - j;
  careerFormBoxCount += 10;
  if (k <= 5) {
    const parser = new DOMParser();
    const text = `<div class="careerFormBox">
                    <div class="title">経歴<span class="title_label">${k + 1}</span></div>
                    <div class="columns">
                      <div class="column col-6">
                        <div class="form-group required"><label class="form-label" for="creator_info_careers_attributes_0_開始日">開始日</label><input required="required" class="form-input career_start" type="month" name="creator_info[careers_attributes][${careerFormBoxCount}][start_year_and_month]" id="creator_info_careers_attributes_0_start_year_and_month" /></div>
                      </div>
                      <div class="column col-6">
                        <div class="form-group"><label class="form-label" for="creator_info_careers_attributes_0_終了日">終了日</label><input class="form-input career_end" type="month" name="creator_info[careers_attributes][${careerFormBoxCount}][end_year_and_month]" id="creator_info_careers_attributes_0_end_year_and_month" /></div>
                      </div>
                    </div>
                    <div class="form-group required"><label class="form-label" for="creator_info_careers_attributes_0_会社名">会社名</label><input required="required" class="form-input" type="text" name="creator_info[careers_attributes][${careerFormBoxCount}][company_name]" id="creator_info_careers_attributes_0_company_name" /></div>
                    <div class="form-group required"><label class="form-label" for="creator_info_careers_attributes_0_業務内容・実績">業務内容・実績</label><textarea required="required" class="form-input" name="creator_info[careers_attributes][${careerFormBoxCount}][business_content]" id="creator_info_careers_attributes_0_business_content"></textarea><p class="description">※2,000文字以内で入力してください</p></div>
                    <div class="closeBtn deleteNewCareer">削除</div>
                  </div>`;
    const dom = parser.parseFromString(text, "text/html");
    const careerBox = document.getElementById("careerBox");
    careerBox.appendChild(dom.body);
    if (k == 5) {
      this.remove();
    }
    document.querySelectorAll(".career_start").forEach(function (input) {
      input.addEventListener("change", checkCareerEnd);
    });
    document.querySelectorAll(".career_end").forEach(function (input) {
      input.addEventListener("change", checkCareerStart);
    });
  }

  document.querySelectorAll(".deleteNewCareer").forEach(function (btn) {
    btn.addEventListener("click", function (event) {
      event.target.parentNode.remove();
      const addBtn = document.getElementById("careerAddBtn");
      if (!addBtn) {
        appendCareerAddBtn();
      }
      updateCareers();
    });
  });
};

window.updateCareers = function () {
  let count = 0;
  document.querySelectorAll(".careerFormBox").forEach(function (career, i) {
    if (!career.classList.contains("hide")) {
      count++;
      career.querySelector(".title_label").textContent = count;
    }
  });
};

window.appendCareerAddBtn = function () {
  const careerParent = document.getElementById("careerParent");
  const text = '<div id="careerAddBtn"><i class="icon icon-plus"></i>経歴を追加</div>';
  const parser = new DOMParser();
  const dom = parser.parseFromString(text, "text/html");
  const btn = dom.body;
  btn.addEventListener("click", addCareerBox);
  careerParent.appendChild(btn);
};

window.checkCareerStart = function () {
  const end = this.value;
  const start = this.parentNode.parentNode.parentNode.parentNode.querySelector(".career_start").value;
  if (end && start) {
    if (start > end) {
      this.value = "";
      showDialog("開始日よりも後の日付を入力してください");
    }
  }
};

window.checkCareerEnd = function () {
  const start = this.value;
  const end = this.parentNode.parentNode.parentNode.parentNode.querySelector(".career_end").value;
  if (end && start) {
    if (start > end) {
      this.value = "";
      showDialog("終了日よりも前の日付を入力してください");
    }
  }
};

window.validUrlMaxLength = function () {
  const value = this.value;
  if (value.length > 250) {
    alert("入力可能な文字数を越えています。最大250文字まで入力が可能です。");
    this.value = "";
  }
};
